import fetch from "../axiosConfig";

// 查询学术工资发放
export function getAcademicSalaryDistribution(params) {
    return fetch({
        url: "/academicSalaryPayAct/getPageList",
        method: "GET",
        params
    })
}

// 学术工资发放暂存
export function salaryDistributionSaveDraft(data) {
    return fetch({
        url: "/academicSalaryPayAct/saveDraft",
        method: "POST",
        data
    })
}

// 查询学术工资发放
export function exportSalaryDistribution(params) {
    return fetch({
        url: "/academicSalaryPayAct/exportSalaryDetailList",
        method: "GET",
        params,
        responseType: 'blob',
    })
}

// 资金活动发放导出
export function exportSalaryDetailList(params) {
    return fetch({
        url: "/academicFundTransferPayAct/exportSalaryDetailList",
        method: "GET",
        params,
        responseType: 'blob',
    })
}



// 查询学术工资发放详情
export function getSalaryDistributionDetail(params) {
    return fetch({
        url: "/academicSalaryPayAct/getById",
        method: "GET",
        params
    })
}

// 删除学术工资发放详情
export function deleteSalaryDistributionDetail(params) {
    return fetch({
        url: "/academicSalaryPayAct/delById",
        method: "GET",
        params
    })
}
// 提交学术工资发放
export function academicSalarySubmitApply(data) {
    return fetch({
        url: "/academicSalaryPayAct/submitApply",
        method: "POST",
        data
    })
}

// 学术工资发放审批
export function salaryDistributionRatify(data) {
    return fetch({
        url: "/academicSalaryPayAct/audit",
        method: "POST",
        data
    })
}

// 查询学术活动资金发放
export function getAcademicSalaryAppropriate(params) {
    return fetch({
        url: "/academicFundTransferPayAct/getPageList",
        method: "GET",
        params
    })
}

// 查询学术活动资金发放详情
export function getSalaryAppropriateDetail(params) {
    return fetch({
        url: "/academicFundTransferPayAct/getById",
        method: "GET",
        params
    })
}

// 学术活动资金发放暂存
export function salaryAppropriateSaveDraft(data) {
    return fetch({
        url: "/academicFundTransferPayAct/saveFormDraft",
        method: "POST",
        data
    })
}

// 学术活动资金发放导入暂存
export function salaryAppropriateImportSaveDraft(data) {
    return fetch({
        url: "/academicFundTransferPayAct/saveImportDraft",
        method: "POST",
        data
    })
}

// 学术活动资金发放详情删除
export function salaryAppropriateDelete(params) {
    return fetch({
        url: "/academicFundTransferPayAct/delById",
        method: "GET",
        params
    })
}

// 学术活动资金发放提交
export function salaryAppropriateConfirm(data) {
    return fetch({
        url: "/academicFundTransferPayAct/submitFormApply",
        method: "POST",
        data
    })
}

// 学术活动资金发放导入提交
export function salaryAppropriateImportConfirm(data) {
    return fetch({
        url: "/academicFundTransferPayAct/submitImportApply",
        method: "POST",
        data
    })
}

// 学术活动资金发放审批
export function salaryAppropriateRatify(data) {
    return fetch({
        url: "/academicFundTransferPayAct/audit",
        method: "POST",
        data
    })
}

// 发放工资
export function getAcademicSalaryPayList(params) {
    return fetch({
        url: "/academicSalaryPayAct/getSalaryPayList",
        method: "GET",
        params
    })
}
// 发学术活动发放资金
export function getTransferPayList(params) {
    return fetch({
        url: "/academicFundTransferPayAct/getTransferPayList",
        method: "GET",
        params
    })
}
// 根据业务类型及ID查询付款账号
// /academicPayAct/getPayAccount

export function getPayAccount(params) {
    return fetch({
        url: "/academicPayAct/getPayAccount",
        method: "GET",
        params
    })
}
// 发工资
export function batchPay(data) {
    return fetch({
        url: "/academicPayAct/batchPay",
        method: "POST",
        data
    })
}

//短信二次验证接口
//
export function smsValidate(data) {
    return fetch({
        url: "/academicPayAct/smsValidate",
        method: "POST",
        data
    })
}
// excel预览
export function excelToPdfPreview(params) {
    return fetch({
        url: "/asposePdf/excelToPdfPreview",
        method: "GET",
        responseType: 'arraybuffer',
        params
    })
}

// excel预览
export function getAcademicProvinces() {
    return fetch({
        url: "/organization/getAcademicProvinces",
        method: "GET"
    })
}

// 查询商户
export function getMerchantInfo(params) {
    return fetch({
        url: "/academicPayAct/getMerchantInfo",
        method: "GET",
        params
    })
}

/**根据省份查看康贝账户 */
export function getKbAccount(params) {
  return fetch({
      url: "/academicCommon/getKbAccount",
      method: "GET",
      params
  })
}

/** 学术活动发放作废 */
export function disuseFundPay(data) {
  return fetch({
      url: "/academicFundTransferPayAct/disuse",
      method: "post",
      data
  })
}
/**工资作废  */
export function disuseSalaryPay(data) {
  return fetch({
      url: "/academicSalaryPayAct/disuse",
      method: "post",
      data
  })
}

/** 预算限制 */
export  function getLimitBudgetReportingCount(params) {
  return fetch({
      url: "/academicApply/limitBudgetReportingCount",
      method: "get",
      params
  })
}

/** 发放工资预算 */
export  function getRestrictPayAmount(params) {
  return fetch({
      url: "/academicApply/restrictPayAmount",
      method: "get",
      params
  })
}




// WEBPACK FOOTER //
// ./src/api/academic/academicSalary.js